function isEmptyObject(value: unknown): value is null | undefined | Record<string, never> {
  return value == null || (typeof value === 'object' && Object.keys(value).length === 0);
}

export default isEmptyObject;
